export default __webpack_public_path__ + "static/media/cscenter_banner.ad975a1d.png";